import { Module } from 'vuex';
import { actions } from '@/store/filters-events/actions';
import { getters } from '@/store/filters-events/getters';
import { mutations } from '@/store/filters-events/mutations';
import { state } from '@/store/filters-events/state';
import { RootState } from '@/models/states/root-state.model';
import { FiltersEventsState } from '@/models/states/filters-state.model';

const namespaced: boolean = true;

export const filtersEvents: Module<FiltersEventsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
